import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { useTranslationsContext } from '../../context/TranslationsContext';

import {
  CurrentSubscriberSummaryContainer,
  CurrentSubscriberHeader,
  CurrentSubscriberMain,
  CurrentSubscriberPricingMain,
  DueLabel,
  SummaryLineItemMain,
  SummaryAmountAdd,
  SummaryAmountSubtract,
  SummaryLineItemName,
  SummaryAmountSimplePrice
} from './css';
import { getPathVariables } from '../../misc';

const CurrentSubscriberSummaryCard = ({ total }) => {
  const {
    WLS: {
      WIRELESS_ORDER_DETAILS: {
        SideSummary: {
          Summary,
          DueToday,
          DueMonthly
        }
      }
    }
  } = useTranslationsContext();

  const getFormattedPricing = price => {
    const locale = getPathVariables(window.location.pathname)[0];
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    const updatedprice = formatter.format(price);
    return updatedprice;
  };
  const dueNow = _.get(total, 'currentSubscriberTotal.totalOneTime', 0);
  const dueMonthly = _.get(total, 'currentSubscriberTotal.totalMonthly', 0);
  const dueNowList = _.get(total, 'summary.dueNowList', []);
  const dueMonthlyList = _.get(total, 'summary.dueMonthlyList', []);

  const getSummaryList = list =>
    list.map(listItem => (
      <SummaryLineItemMain>
        <SummaryLineItemName>{listItem.name}</SummaryLineItemName>
        {listItem.type === 'SUB' ? (
          <SummaryAmountSubtract>
            ({getFormattedPricing(listItem.price)})
          </SummaryAmountSubtract>
        ) : (
          <SummaryAmountAdd>
            {getFormattedPricing(listItem.price)}
          </SummaryAmountAdd>
        )}
      </SummaryLineItemMain>
    ));

  return (
    <CurrentSubscriberSummaryContainer>
      <CurrentSubscriberHeader>
        {Summary}
      </CurrentSubscriberHeader>
      <CurrentSubscriberMain>
        <CurrentSubscriberPricingMain>
          <DueLabel>{DueToday}</DueLabel>
          <span>{getFormattedPricing(dueNow)}</span>
        </CurrentSubscriberPricingMain>
        <div>{dueNowList.length > 0 && getSummaryList(dueNowList)}</div>
      </CurrentSubscriberMain>
      <CurrentSubscriberMain>
        <CurrentSubscriberPricingMain>
          <DueLabel>{DueMonthly}</DueLabel>
          <span>{getFormattedPricing(dueMonthly)}</span>
        </CurrentSubscriberPricingMain>
        <div>{dueMonthlyList.length > 0 && getSummaryList(dueMonthlyList)}</div>
      </CurrentSubscriberMain>
    </CurrentSubscriberSummaryContainer>
  );
};

CurrentSubscriberSummaryCard.propTypes = {
  total: PropTypes.objectOf(PropTypes.any).isRequired
};

export default CurrentSubscriberSummaryCard;
